import { useState, useEffect } from 'react';
import { Container } from '../../../component/container/Container';
import { Title } from '../../../component/title/Title';
import Form from './form/Form.component';
import Group from '../groups/interfaces/Group';
import TransferList from '../../../component/transferList/TransferList.component';
import { getByGroups, getGroups, putGroups } from '../groups/Groups.service';
import { useSnackbar } from '../../../context/Snackbar';
import Functionality from '../functionality/interfaces/Functionality';
import { INITIAL_VALUES } from '../groups/utils/INITIAL_VALUES';
import { getFunctionality } from '../functionality/Functionality.service';

export default function Permission() {
  const { setSnackbar } = useSnackbar();
  const [group, setGroup] = useState<Group>();
  const [functionality, setFunctionality] = useState<Functionality[]>([]);
  const [reload, setReload] = useState<boolean>(true);

  const getData = () => {
    setReload(true);
    getFunctionality()
      .then((res) => {
        setFunctionality(res.data.data);
      })
      .catch((error) => {
        console.log('error', error);
      });
    setReload(false);
  };
  useEffect(() => {
    getData();
  }, []);

  const handleSubmitForm = (group: Group) => {
    setGroup(group);
  };

  const getGroup = async () => {
    try {
      setReload(true);
      if (group?.id) {
        const res = await getByGroups(group?.id);
        setGroup(res.data[0]);
      }
      setReload(false);
    } catch (e) {
      console.log('Erro ao consultar grupos!', e);
      setSnackbar({ msg: 'Erro ao consultar grupos!', type: 'error' });
      return [];
    }
  };

  const reduceObjectFunctionality = (funcionalidades: Functionality[]) => {
    let funcionalidadesAux: number[] = [];
    funcionalidades.map((el: Functionality) => {
      if (el.id) {
        funcionalidadesAux.push(el.id);
      }
      return el;
    });
    return funcionalidadesAux;
  };

  const register = async (funcionalidades: Functionality[]) => {
    let groupAux: Group | undefined = JSON.parse(JSON.stringify(group));
    if (groupAux) {
      groupAux.funcionalidades = reduceObjectFunctionality(funcionalidades);
      setReload(true);
      await putGroups(groupAux)
        .then((res) => {
          getGroup().finally(() =>
            setSnackbar({ msg: 'Permissão atribuida com sucesso!', type: 'success' })
          );
        })
        .catch((error) => {
          console.log('Erro ao atribuir permissão!', error);
          setSnackbar({ msg: 'Erro ao atribuir permissão!', type: 'error' });
        });
    }
  };

  return (
    <>
      <Title>ATRIBUIÇÃO</Title>
      <Container margin='25px 0px'>
        <Form initialValues={INITIAL_VALUES} handleSubmitForm={handleSubmitForm} />
      </Container>
      {group && (
        <TransferList
          list={group.funcionalidades || []}
          listAvailable={[...functionality]}
          handleSubmit={register}
          request={reload}
          titleRight='Funcionalidades Disponíveis'
          titelLeft='Funcionalidades Selecionadas'
          propertyName={{ id: 'id', name: 'nome' }}
          blockSubmitTransferList
        />
      )}
    </>
  );
}
